import { combineReducers } from "redux";
import systemReducer from "./system/system.reducer";

const RootReducer = combineReducers({
    System: systemReducer,
});

export default RootReducer;
